import { useTranslation } from 'react-i18next';
import { ActualityAggregatedHqExtendedStatsDataColumn } from '../store/actuality.kpi.types';

export type ActualityStatsCategoryDesc = {
  key: string;
  title: string;
  metrics: ActualityAggregatedHqExtendedStatsDataColumn[];
  metricGroups: {
    title: string;
    metrics: ActualityAggregatedHqExtendedStatsDataColumn[];
  }[];
  icon?: React.ReactNode | string;
};

// Hook to get translated categories with dynamic currency and measurement units
export const useActualityStatsCategories = (
  systemCurrency?: string,
  sizeMeasureValue?: string,
): ActualityStatsCategoryDesc[] => {
  const { t } = useTranslation('feed');

  return [
    {
      key: 'share',
      title: t`Share`,
      icon: '%',
      metrics: [
        'analyzedDurationTravellingStart',
        'analyzedDurationTravellingEnd',
        'analyzedDurationTravellingInternal',
        'analyzedDurationTravellingVertical',
        'analyzedDurationHandling',
        'analyzedDurationPicking',
        'analyzedDurationReordering',
      ],
      metricGroups: [
        {
          title: t`Travelling`,
          metrics: [
            'analyzedDurationTravellingStart',
            'analyzedDurationTravellingEnd',
            'analyzedDurationTravellingInternal',
            'analyzedDurationTravellingVertical',
          ],
        },
        {
          title: t`Handling`,
          metrics: [
            'analyzedDurationHandling',
            'analyzedDurationPicking',
            'analyzedDurationReordering',
          ],
        },
      ],
    },
    {
      key: 'duration',
      title: t`Duration`,
      icon: 'h',
      metrics: [
        'analyzedDurationTravellingStart',
        'analyzedDurationTravellingEnd',
        'analyzedDurationTravellingInternal',
        'analyzedDurationTravellingVertical',
        'analyzedDurationHandling',
        'analyzedDurationPicking',
        'analyzedDurationReordering',
      ],
      metricGroups: [
        {
          title: t`Travelling`,
          metrics: [
            'analyzedDurationTravellingStart',
            'analyzedDurationTravellingEnd',
            'analyzedDurationTravellingInternal',
            'analyzedDurationTravellingVertical',
          ],
        },
        {
          title: t`Handling`,
          metrics: [
            'analyzedDurationHandling',
            'analyzedDurationPicking',
            'analyzedDurationReordering',
          ],
        },
      ],
    },
    {
      key: 'cost',
      title: t`Cost`,
      icon: systemCurrency || '$',
      metrics: [
        'analyzedCostTravellingStart',
        'analyzedCostTravellingEnd',
        'analyzedCostTravellingInternal',
        'analyzedCostTravellingVertical',
        'analyzedCostHandling',
        'analyzedCostPicking',
        'analyzedCostReordering',
      ],
      metricGroups: [
        {
          title: t`Travelling`,
          metrics: [
            'analyzedCostTravellingStart',
            'analyzedCostTravellingEnd',
            'analyzedCostTravellingInternal',
            'analyzedCostTravellingVertical',
          ],
        },
        {
          title: t`Handling`,
          metrics: [
            'analyzedCostHandling',
            'analyzedCostPicking',
            'analyzedCostReordering',
          ],
        },
      ],
    },

    {
      key: 'distance',
      title: t`Distance`,
      icon: sizeMeasureValue || 'm',
      metrics: [
        'analyzedDistanceTravellingStart',
        'analyzedDistanceTravellingEnd',
        'analyzedDistanceTravellingInternal',
        'analyzedDistanceTravellingVertical',
      ],
      metricGroups: [
        // {
        //   title: t`Start/End`,
        //   metrics: ['analyzedDistanceTravellingStart', 'analyzedDistanceTravellingEnd'],
        //   },
        {
          title: t`Start`,
          metrics: ['analyzedDistanceTravellingStart'],
        },

        {
          title: t`Internal`,
          metrics: ['analyzedDistanceTravellingInternal'],
        },
        {
          title: t`End`,
          metrics: ['analyzedDistanceTravellingEnd'],
        },
        // {
        //   title: t`Vertical`,
        //   metrics: ['analyzedDistanceTravellingVertical'],
        // },
      ],
    },

    // {
    //   key: 'labour',
    //   title: t`Time`,
    //   icon: 'time',
    //   // chartType: 'stackedLine',
    //   metrics: [
    //     // 'analyzedDurationTravellingStart',
    //     // 'analyzedDurationTravellingEnd',
    //     // 'analyzedDurationTravellingInternal',
    //     // 'analyzedDurationTravellingVertical',
    //     // 'analyzedDurationHandling',
    //     // 'analyzedDurationPicking',
    //     // 'analyzedDurationReordering',
    //     'totalIdleDurationBetweenJobs',
    //     'totalIdleDurationShiftStart',
    //     'totalIdleDurationShiftEnd',
    //     'totalEmployeeActivityDuration',
    //     'analyzedDuration',
    //   ],
    //   metricGroups: [
    //     {
    //       title: t`Idle`,
    //       metrics: ['totalIdleDurationBetweenJobs'],
    //     },

    //     {
    //       title: t`Worked`,
    //       metrics: ['analyzedDistanceTravellingInternal'],
    //     },
    //   ],
    // },
  ];
};

// Simple utility to convert category to StackedLineChart config
export const categoryToStackedLineConfig = (
  category: ActualityStatsCategoryDesc,
) => ({
  key: category.key,
  title: category.title,
  icon: category.icon,
  metrics: category.metrics,
  metricGroups: category.metricGroups,
});
